import React from "react";
import "./Home.scss";

import withMotion from "../../Utils/withMotion";

//Panels
import Hero from "./Hero/Hero";
import Featured from "./Featured/Featured";
import History from "./History/History";
import Knowledge from "./Knowledge/Knowledge";
import Services from "./Services/Services";
import HowItWorks from "./HowItWorks/HowItWorks";
import Reviews from "./Reviews/Reviews";
import WhyUs from "./WhyUs/WhyUs";
import FAQs from "./FAQs/FAQs";
// import Sales from "./Sales";
import { ViewPavers } from "../../CTA/CTA";

// SEO
import SEO from "../../SEO/index.js";
import StructuredData from "../../SEO/structuredData";

const Home = () => {
  return (
    <>
      <SEO
        title="LA's Top Paving Stone Installers & Providers - Pacific Pavingstone"
        description="We have been installing paving stone driveways, patios and pool decks in Southern California since 1999. Get a free estimate today!"
        profileURL={"https://www.pacificpavingstone.com/"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org",
          "@type": "HomeAndConstructionBusiness",
          name: "Pacific Pavingstone",
          image:
            "https://www.pacificpavingstone.com/static/media/hero-unit.7f2f0943.jpg",
          url: "https://www.pacificpavingstone.com/",
          telephone: "(818) 464-4620",
          email: "info@pacificoutdoorliving.com",
          founder: "Terry Morrill",
          foundingDate: "1999",
          logo: "https://www.pacificpavingstone.com/static/media/logo-2.bf1f43f9.png",
          paymentAccepted: "Cash, Credit Card, Financing, Invoice",
          description:
            "Pacific Pavingstone has been LA’s and Southern California’s top paving stone installer and provider since 1999. Pacific Pavingstone has twice earned a spot on the Inc. 500 list of fastest growing companies and has completed over 10,000 jobs, earning us a reputation for excellence and unparalleled quality of service.",
          address: {
            "@type": "PostalAddress",
            streetAddress: "8309 Tujunga Ave Ste. 101",
            addressLocality: "Sun Valley",
            addressRegion: "CA",
            postalCode: "91352",
            addressCountry: "US",
          },
          openingHoursSpecification: [
            {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
              ],
              opens: "09:00",
              closes: "18:00",
            },
            {
              "@type": "OpeningHoursSpecification",
              dayOfWeek: "Saturday",
              opens: "09:00",
              closes: "17:00",
            },
          ],
          sameAs: [
            "https://www.facebook.com/PacificPavingstone/",
            "https://www.linkedin.com/in/pacific-pavingstone-74a7a414b/",
            "https://www.pinterest.com/pacificoutdoor/pacific-pavingstone/",
            "https://www.bbb.org/us/ca/sun-valley/profile/paving-contractors/pacific-pavingstone-1216-13201048",
            "https://www.houzz.com/professionals/stone-pavers-and-concrete/pacific-pavingstone-pfvwus-pf~1134356150",
          ],
        }}
      />
      <div className="container-fluid page-home">
        <Hero />
        <Featured />
        <History />
        <WhyUs />
        <Knowledge />
        <Services />
        <HowItWorks />
        <Reviews />
        {/* <Sales /> */}
        <FAQs />
        <ViewPavers />
      </div>
    </>
  );
};

export default withMotion(Home);
